import { render, staticRenderFns } from "./uploadAdress.vue?vue&type=template&id=507a7828&scoped=true"
import script from "./uploadAdress.vue?vue&type=script&lang=js"
export * from "./uploadAdress.vue?vue&type=script&lang=js"
import style0 from "./uploadAdress.vue?vue&type=style&index=0&id=507a7828&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a7828",
  null
  
)

export default component.exports